import { render, staticRenderFns } from "./fusion-visual-demo.vue?vue&type=template&id=2554dcfd&scoped=true"
import script from "./fusion-visual-demo.vue?vue&type=script&lang=js"
export * from "./fusion-visual-demo.vue?vue&type=script&lang=js"
import style0 from "./fusion-visual-demo.vue?vue&type=style&index=0&id=2554dcfd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2554dcfd",
  null
  
)

export default component.exports